import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubscriptionComponent } from './subscription-component/subscription.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { PaymentCancelComponent } from './payment-cancel/payment-cancel.component';
import { authGuard } from 'src/app/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: SubscriptionComponent,
  },
  {
    path: 'success',
    component: PaymentSuccessComponent,
    canActivate: [authGuard],
  },
  {
    path: 'cancel',
    component: PaymentCancelComponent,
    canActivate: [authGuard],
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubscriptionRoutingModule { }
